import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../Config";
import Topbar from "../Components/Topbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ServiceContentSectionsLanding() {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${config.apiUrl}/api/v1/admin/service?disable_pagination=true`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setServices(Array.isArray(data) ? data : []);
      } else {
        throw new Error("Failed to fetch services");
      }
    } catch (e) {
      toast.error(e.message);
      setServices([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Topbar />
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="mb-6 flex items-center gap-4">
          <button
            onClick={() => navigate("/services")}
            className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            ← Services
          </button>
          <h1 className="text-2xl font-bold text-gray-900">Service content sections</h1>
        </div>
        <p className="text-sm text-gray-500 mb-6">
          Select a service to manage content sections shown to users after they book.
        </p>
        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-indigo-600" />
            <p className="mt-4 text-gray-600">Loading services...</p>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <ul className="divide-y divide-gray-200">
              {services.map((service) => (
                <li key={service.service_id} className="flex items-center justify-between px-4 py-3 hover:bg-gray-50">
                  <span className="text-gray-900 font-medium">{service.title || service.service_id}</span>
                  <button
                    onClick={() => navigate(`/services/${service.service_id}/content-sections`)}
                    className="px-3 py-1.5 text-sm bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                  >
                    Manage sections
                  </button>
                </li>
              ))}
            </ul>
            {services.length === 0 && (
              <div className="p-8 text-center text-gray-500">No services found.</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ServiceContentSectionsLanding;
